import moment from 'moment'
import Client from '../../lib/geometric-webservice-client'

const REFRESH_INTERVAL = process.env.VUE_APP_REFRESH_INTERVAL
export default {
  namespaced: true,
  state: {
    syncData: null,
    syncStatus: 'idle'
  },
  mutations: {
    setSyncData (state, { totalCustomersToGeocode, totalCustomersUpdated }) {
      state.syncData = { totalCustomersToGeocode, totalCustomersUpdated }
    },
    setSyncStatus (state, status) {
      state.syncStatus = status
    }
  },
  actions: {
    async syncCustomers ({ commit, rootState }) {
      commit('setSyncStatus', 'caching')
      const token = rootState.auth.token
      const client = new Client(token, process.env.VUE_APP_WEBSERVICE_URL)
      try {
        const { totalCustomersUpdated, totalCustomersToGeocode } = await client.cacheCustomers()
        commit('setSyncStatus', 'importing')
        const { status, hereJobId } = await client.startGeocoder()
        console.log(status, hereJobId)
        hereJobId && await client.checkHereStatus(hereJobId)
        await client.importCustomers(false)
        commit('setSyncData', { totalCustomersToGeocode, totalCustomersUpdated })
        commit('setSyncStatus', 'idle')
      } catch (err) {
        console.log(err)
        commit('setSyncStatus', 'idle')
        alert('Something went wrong, please try again later')
        throw err
      }
    }
  },
  getters: {
    syncDataDisplay: state => {
      if (!state.syncData) return null
      const { totalCustomersToGeocode } = state.syncData
      return [
        { description: 'totalCustomersToGeocode', value: totalCustomersToGeocode }
      ]
    },
    isRecentlySync: (state, getters, rootState) => {
      const now = moment(new Date())
      const lastUpdate = rootState.user.params.lastUpdate
      if (!lastUpdate) return false
      const lastUpdateDate = moment(lastUpdate)
      const duration = moment.duration(now.diff(lastUpdateDate))
      const seconds = duration.asSeconds()
      const isRecentlySync = seconds < parseInt(REFRESH_INTERVAL)
      return isRecentlySync
    }
  }
}
